import type { CustomerInvoiceStatusMapping, InvoiceStatusFilter } from './types';

// Status filter mapping for GraphQL queries
export const INVOICE_STATUS_MAPPING: CustomerInvoiceStatusMapping = {
  Open: 'Open',
  All: null,
};

// Type guard for InvoiceStatusFilter validation
const VALID_STATUS_VALUES = Object.keys(INVOICE_STATUS_MAPPING) as InvoiceStatusFilter[];

export const isInvoiceStatusFilter = (value: string): value is InvoiceStatusFilter =>
  VALID_STATUS_VALUES.includes(value as InvoiceStatusFilter);

// Default values
export const DEFAULT_STATUS = 'Open' as const;
